import { useMutation } from "@tanstack/react-query";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import type { CreateReposition, Reposition } from "../types/Replenishment";

export const createReposition = async (
  repositionData: CreateReposition,
): Promise<Reposition> => {
  try {
    console.log("Datos enviados al servidor:", repositionData);

    const response = await fetcher.post(
      `${API.GESLUB}/repositions`,
      repositionData,
    );

    console.log("Respuesta del servidor:", response);

    return response.data as Reposition;
  } catch (error) {
    console.error("Error en la solicitud de creación de reposición", error);
    throw error;
  }
};

export const useCreateReposition = () => {
  return useMutation({
    mutationFn: createReposition,
    onError: (error) => {
      console.error("Error al crear la reposición:", error);
    },
    onSuccess: (data) => {
      console.log("Reposición creada exitosamente:", data);
    },
  });
};
